export default __webpack_public_path__ + "static/media/uploadIcon.e644e4e5.svg";